export default __webpack_public_path__ + "static/media/DNo.20-8.25c1069e.jpg";